import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import HeroBannerImage from "../assets/images/banner.png";

const HeroBanner = () => (
  <Box
    sx={{ mt: { lg: "212px", xs: "70px" }, ml: { sm: "50px" } }}
    position="relative"
    p="20px"
  >
    <Typography
      fontFamily="Poppins"
      color="#FF2625"
      fontWeight="650"
      fontSize="59px"
    >
      The Fitness Studio
    </Typography>
    <Typography
      fontFamily="Poppins"
      fontWeight={450}
      sx={{ fontSize: { lg: "44px", xs: "40px" } }}
      mb="23px"
      mt="30px"
    >
      Sweat, Smile <br />
      And Repeat
    </Typography>
    <Typography fontFamily="Poppins" fontSize="20px" lineHeight="35px">
      Check out the most effective exercises personalized to you
    </Typography>
    <Stack>
      <a
        href="#exercises"
        style={{
          fontFamily: "Poppins",
          marginTop: "45px",
          textDecoration: "none",
          width: "200px",
          textAlign: "center",
          background: "#FF2625",
          padding: "14px",
          fontSize: "20px",
          textTransform: "none",
          color: "white",
          borderRadius: "10px",
          boxShadow: "5px 5px #444",
        }}
      >
        Explore Exercises
      </a>
    </Stack>
    <Typography
      fontWeight={600}
      color="#FF2625"
      sx={{
        fontFamily: "Poppins",
        opacity: "0.1",
        display: { lg: "block", xs: "none" },
        fontSize: "200px",
      }}
    >
      Exercise
    </Typography>
    <img
      src={HeroBannerImage}
      alt="hero-banner"
      className="hero-banner-img"
      style={{
        borderRadius: "0px 0px 15px 100px",
        boxShadow: "3px 3px 30px #ff706f",
      }}
    />
  </Box>
);

export default HeroBanner;
